import { createContext, use, useContext, useEffect, useReducer } from 'react';
import ajaxNetwork from '../util/remote/ajaxNetwork';

const initialState = { 
    selectedDevice: null,
    deviceInfo: null,
    fetchingDevice: false,
    voucherInfo: null,
    fetchingVoucher: false,
    selectedVoucher: null,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const NetworkContext = createContext();

export const NetworkProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

 
  useEffect(() => {
    if(state.selectedVoucher){
      getVoucherInfo(state.selectedVoucher);
    }
  }, [state.selectedVoucher]);

  

  const setSelectedDevice = (mac_address) => {
    dispatch({type: 'selectedDevice', payload: mac_address});
  };

  const setSelectedVoucher = (voucher_code) => {
    dispatch({type: 'selectedVoucher', payload: voucher_code});
  };

  const getVoucherInfo = async (voucher_code) => {
    dispatch({type: 'voucherInfo', payload: null}); // Clear previous info
    dispatch({type: 'fetchingVoucher', payload: true});
    const server_response = await ajaxNetwork.fetchVoucherInfo(voucher_code);
    dispatch({type: 'fetchingVoucher', payload: false});
    if(server_response.status === "OK"){
      dispatch({type: 'voucherInfo', payload: server_response.details});
    } else {
      dispatch({type: 'voucherInfo', payload: "404"}); // Indicate not found or error
    }
  };

 
  return(
    <NetworkContext.Provider value={{
      ...state, 
      dispatch,
      setSelectedDevice,
      getVoucherInfo,
      setSelectedVoucher,       
    }}>
      {children}
    </NetworkContext.Provider>
  )

}

export const useNetwork = ()=>useContext(NetworkContext);

